/**Dependencies */
import React, { useEffect, useState } from "react";

/**Components */
import { Row, Col, Card, Button, Modal } from "react-bootstrap";
import { CarouselCards } from "../components/CarouselCards";
import { BannerDudas } from "../components/BannerDudas";

/**Styles */
import "../styles/transportation.scss";

/**Images */
import bannerRentaAutos from "../images2/bannerRentaAuto.png";
import BannerNecesitasAyuda from "../images2/Banner-contacto-renta-autos.png";
import BannerNecesitasAyudaMovil from "../images2/Banner-contacto-renta-autos-movil.png";
import { IoMdPerson } from "react-icons/io";
import { FaBagShopping } from "react-icons/fa6";
import { TbManualGearbox } from "react-icons/tb";

import { getCollections } from "../services/CollectionsService";
import { getAutos } from "../services/rentaAutosService";
import { Currency } from "../helpers";
import { FaDollarSign } from "react-icons/fa";
import { GeneralForm } from "../components/GeneralForm";
import { Autoplay } from "swiper/modules";
import { SwiperSlide, Swiper } from "swiper/react";

export const RentaAutos = () => {
  const [collections, setCollections] = useState([]);
  const [autos, setAutos] = useState([]);
  const [show, setShow] = useState(false);
  const [modalAuto, setModalAuto] = useState([]);
  useEffect(() => {
    const obtenerCollections = async () => {
      try {
        const response = await getCollections();
        setCollections(response);
      } catch (error) {
        throw new Error("Error fetching Data. Collections: " + error);
      }
    };
    obtenerCollections();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const obtenerAutos = async () => {
      try {
        const response = await getAutos();
        setAutos(response);
      } catch (error) {
        throw new Error("Error fetching Data. Autos: " + error);
      }
    };
    obtenerAutos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div>
      <div className="section-card container py-4">
        <div className="d-flex flex-column flex-lg-row flex-sm-row border-top align-items-center justify-content-center border-1 border-black">
          <div className="banner-carros py-5 text-center text-lg-start">
            <h1
              style={{ color: "#3764ab", fontSize: "45px" }}
              className="border-2 pt-4 banner-carros title-cars fw-bolder"
            >
              Las mejores experiencias en cada destino
            </h1>
            <p style={{ color: "#3764ab" }}>
              Tours Culturales y gastronómicos hasta deportes extremos y
              aventuras al aire libre.
            </p>
          </div>
          <div className="py-5 w-100">
            <img src={bannerRentaAutos} alt="" className="w-100" />
          </div>
        </div>
      </div>

      <div
        className="section-list-vehicules py-5"
        style={{ background: "#3764ab1c" }}
      >
        <div className="container">
          <Swiper
            pagination={{
              clickable: true,
            }}
            modules={[Autoplay]}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            //direction={"vertical"}
            spaceBetween={100}
            breakpoints={{
              300: {
                slidesPerView: 1,
              },
              1024: {
                slidesPerView: 2,
              },
              1400: {
                slidesPerView: 3,
              },
            }}
            className="swiper"
          >
            {autos.map((infoVehicules, index) => (
              <SwiperSlide>
                <div key={index + 1} className="w-100">
                  <div className="cards-hotels py-3">
                    <Card
                      className={
                        "shadow rounded-4 border-0 " +
                        (infoVehicules?.destacado === 0 ? "" : "destacado")
                      }
                    >
                      <Row>
                        <Col lg={12} md={12} sm={12}>
                          <div className="w-100 d-flex p-3 justify-content-start">
                            <img
                              src={
                                "https://panel.marzahtravel.com/assets/uploads/rentaAutos/autos/" +
                                infoVehicules?.logo_rental_car
                              }
                              className="pb-2"
                              alt=""
                            />
                          </div>

                          <img
                            src={
                              "https://panel.marzahtravel.com/assets/uploads/rentaAutos/autos/" +
                              infoVehicules?.image_auto
                            }
                            alt=""
                            className="w-100 p-5 pb-2"
                          />
                        </Col>
                        <Col lg={12} md={12} sm={12}>
                          <div className="p-5 pt-0 pb-0 d-flex justify-content-start font-weight-bold">
                            <h4
                              className={
                                "fw-semibold " +
                                (infoVehicules?.destacado === 0
                                  ? "text-dark"
                                  : "text-light")
                              }
                              style={{ margin: "0" }}
                            >
                              {infoVehicules?.titulo} <br />{" "}
                              <span style={{ fontSize: "17px" }}>
                                {" "}
                                {infoVehicules?.name_auto}{" "}
                              </span>{" "}
                            </h4>
                          </div>
                          <div
                            className="amenities d-grid pt-4"
                            style={{ marginLeft: "40px" }}
                          >
                            <p
                              className={
                                "m-0 " +
                                (infoVehicules?.destacado === 0
                                  ? " text-dark"
                                  : " text-light")
                              }
                              style={{ fontSize: "20px" }}
                            >
                              <FaDollarSign
                                className={
                                  "details-cars " +
                                  (infoVehicules?.destacado === 0
                                    ? "text-destacado"
                                    : "text-light")
                                }
                              />
                              {Currency(infoVehicules?.price).replace("$", "")}{" "}
                              <span style={{ fontSize: "15px" }}>MXN</span> por
                              día
                            </p>
                            <span
                              className={
                                infoVehicules?.destacado === 0
                                  ? "text-dark"
                                  : "text-light"
                              }
                            >
                              <IoMdPerson
                                className={
                                  "details-cars " +
                                  (infoVehicules?.destacado === 0
                                    ? "text-destacado"
                                    : "text-light")
                                }
                              />{" "}
                              {infoVehicules?.total_passengers}
                            </span>
                            <span
                              className={
                                infoVehicules?.destacado === 0
                                  ? "text-dark"
                                  : "text-light"
                              }
                              style={{ marginTop: "10px" }}
                            >
                              <FaBagShopping
                                className={
                                  "details-cars " +
                                  (infoVehicules?.destacado === 0
                                    ? "text-destacado"
                                    : "text-light")
                                }
                              />{" "}
                              {infoVehicules?.total_luggage} maletas{" "}
                            </span>
                            <span
                              className={
                                infoVehicules?.destacado === 0
                                  ? "text-dark"
                                  : "text-light"
                              }
                              style={{ marginTop: "10px" }}
                            >
                              <TbManualGearbox
                                className={
                                  "details-cars " +
                                  (infoVehicules?.destacado === 0
                                    ? "text-destacado"
                                    : "text-light")
                                }
                              />
                              {infoVehicules?.type_car}{" "}
                            </span>
                            <br />
                            {/*   <span className="d-none d-lg-flex">
                            <img
                              src={
                                "https://panel.marzahtravel.com/assets/uploads/rentaAutos/autos/" +
                                infoVehicules?.logo_rental_car
                              }
                              className="pb-2"
                              alt=""
                            />
                          </span> */}
                          </div>
                        </Col>
                        <Col lg={12} md={12} sm={12} className="px-5 pb-4">
                          <Button
                            onClick={() => [
                              handleShow(),
                              setModalAuto(infoVehicules),
                            ]}
                            className={"p-2 w-100 "}
                            style={
                              infoVehicules?.destacado === 0
                                ? { background: "#3764ab", color: "#fff" }
                                : { background: "#fff", color: "#3764ab" }
                            }
                          >
                            Cotízar
                          </Button>
                        </Col>
                      </Row>
                    </Card>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>

      <Modal show={show} centered onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Contáctanos</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <GeneralForm
            urlSection={"/renta-autos"}
            isContactForm={false}
            isRentalCarForm={true}
            data={modalAuto}
          />
        </Modal.Body>
      </Modal>

      <div className="py-2 py-sm-2 py-lg-5">
        <BannerDudas
          imgDudasDesk={BannerNecesitasAyuda}
          imgDudasMovil={BannerNecesitasAyudaMovil}
          bannerDudas={true}
        />
      </div>

      <div className="py-2 py-sm-2 py-lg-2">
        <CarouselCards
          title={"Encuentra más colecciones aquí"}
          cardsInfo={collections}
          seccion={"collections"}
        />{" "}
      </div>
    </div>
  );
};
